<template>
  <div
  class="vue-map-info-icon-wrap"
  @click="iconClick"
  title="View map info"
  v-bind:class="{isMobile: this.isMobile() || this.isTablet(), isDarkMode: isDarkMode}">
    <div
    class="icon-help-wrap"
    title="View map info">
        <img
        v-if="!isDarkMode"
        class="icon" src="../../../assets/img/tri-fold-icon-light-mode.svg" alt="light-mode-icon">
        <img
        v-if="isDarkMode"
        class="icon" src="../../../assets/img/tri-fold-icon-dark-mode.svg" alt="dark-mode-icon">
    </div>
  </div>
</template>

<script>
import vueMqMixin from "../mixins/VueMqMixin";

export default {
  name: 'MapInfoIcon',
  mixins: [vueMqMixin],
  props: {
    isDarkMode: Boolean,
    iconClick: Function
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.vue-map-info-icon-wrap{
  .icon-help-wrap{
    position: fixed;
    top: auto;
    bottom: 120px;
    right: 433px;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 0 0 2px rgba(0,0,0,.1);
    transition: all 0.1s ease;
    text-align: center;

    .icon {
      position: relative;
      display: inline-block;
      width: 20px;
      line-height: 35px;
      font-weight: $bold;
      font-size: 24px;
      top: 6px;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;

      &:hover{
        cursor: pointer;
      }
    }
  }

  &.isMobile{
    .icon-help-wrap{
      bottom: 210px;
      right: 18px;
    }
  }

  &.isDarkMode{
    .icon-help-wrap{
      background-color: $navy;
      box-shadow: 0 0 0 2px rgba(204 ,204 , 204, .75);
    }
  }
}
</style>
